import { browserAgent } from './agent';

export const setCustomAttribute = (
  name: string,
  value: string | number | boolean,
): void => {
  browserAgent.setCustomAttribute(name, value);
};
